import { LOADING, ROLES } from "../actionType/roleManagementType";
import { accountRoles } from "../constant/Constant";
import {
  deleteAuthMethod,
  getAuthMethod,
  patchAuthMethod,
  postAuthMethod,
  putAuthMethod,
} from "../services/HttpServices";

export const createAccountRole = (payload) => (dispatch) => {
  return postAuthMethod(accountRoles, payload)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};

export const updateAccountRole = (payload) => (dispatch) => {
  return patchAuthMethod(accountRoles, payload?.id, payload)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};

export const deleteAccountRole = (id) => (dispatch) => {
  return deleteAuthMethod(`${accountRoles}/${id}`)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};

export const getAllRoles = (payload) => (dispatch) => {
  dispatch({
    type: LOADING,
    payload: true,
  });

  return getAuthMethod(accountRoles)
    .then((res) => {
      dispatch({
        type: ROLES,
        payload: res.data,
      });
      dispatch({
        type: LOADING,
        payload: false,
      });
      return res;
    })
    .catch((err) => {
      dispatch({
        type: ROLES,
        payload: [],
      });
      dispatch({
        type: LOADING,
        payload: false,
      });
      return err;
    });
};

export const searchRoles = (searchKeyword) => (dispatch) => {
  return getAuthMethod(
    `${accountRoles}?sort=name,asc&size=10${searchKeyword ? `&name.contains=${searchKeyword}` : ""}`
  )
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      return err;
    });
};

export const permissionUpdate = (payload) => (dispatch) => {
  dispatch({
    type: LOADING,
    payload: true,
  });

  return putAuthMethod(accountRoles, "bulk-action", payload)
    .then((res) => {
      dispatch({
        type: LOADING,
        payload: false,
      });
      return res;
    })
    .catch((err) => {
      dispatch({
        type: LOADING,
        payload: false,
      });

      return err;
    });
};
